import React from "react";

export function WorkshopCard({ workshop }) {
  return (
    <div className="group relative rounded-lg border p-4 border-gray-200 bg-white transition-colors">
      <div className="flex items-start gap-4">
        {(workshop.workshop_image || "/default-workshop.png") === "/default-workshop.png" ? (
          <div className="relative w-14 h-14 overflow-hidden rounded-md flex-shrink-0 bg-gray-50 border border-gray-200" />
        ) : (
          <div className="relative w-14 h-14 overflow-hidden rounded-md flex-shrink-0">
            <img
              src={workshop.workshop_image || "/default-workshop.png"}
              alt={workshop.workshop_name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/default-workshop.png";
              }}
            />
          </div>
        )}
        <div className="flex flex-col flex-grow min-w-0">
          <h4 className="text-sm font-medium text-gray-900 tracking-tight line-clamp-1">{workshop.workshop_name}</h4>
          <p className="text-sm text-gray-600 mt-1.5 line-clamp-2 leading-relaxed">{workshop.workshop_description || workshop.description || "No description available"}</p>
        </div>
      </div>
    </div>
  );
}
